import { render, staticRenderFns } from "./DailyPuzzles.vue?vue&type=template&id=71309d45&scoped=true"
import script from "./DailyPuzzles.vue?vue&type=script&lang=js"
export * from "./DailyPuzzles.vue?vue&type=script&lang=js"
import style0 from "./DailyPuzzles.vue?vue&type=style&index=0&id=71309d45&prod&scoped=true&lang=css"
import style1 from "./DailyPuzzles.vue?vue&type=style&index=1&id=71309d45&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71309d45",
  null
  
)

export default component.exports